import { OAuthStorage } from 'angular-oauth2-oidc';
import { Injectable, inject } from '@angular/core';
import { AUTH_CONFIG, AuthConfig } from '@lyceo/shared/auth/util-models';

@Injectable({
  providedIn: 'root',
})
export class PrefixLocalStorage implements OAuthStorage {
  private readonly authConfig: AuthConfig = inject<AuthConfig>(AUTH_CONFIG);

  public getItem(key: string): string | null {
    return localStorage.getItem(`${this.authConfig.storagePrefix}/auth/${key}`);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(`${this.authConfig.storagePrefix}/auth/${key}`);
  }

  public setItem(key: string, data: string): void {
    localStorage.setItem(`${this.authConfig.storagePrefix}/auth/${key}`, data);
  }
}
